import React from "react";
import "./css/footer.css";
import facebookIcon from "../assets/img/facebook.svg";
import instagramIcon from "../assets/img/instagram.svg";
import whatsappIcon from "../assets/img/whatsapp.svg";

const socialLinks = [
  {
    href: "https://www.facebook.com/profile.php?id=100067382923058",
    label: "Facebook",
    icon: facebookIcon,
  },
  {
    href: "https://www.instagram.com/iglesiaevangelicadelafe/",
    label: "Instagram",
    icon: instagramIcon,
  },
  {
    href: "https://wa.me/50764330014",
    label: "WhatsApp",
    icon: whatsappIcon,
  },
];

const usefulLinks = [
  { href: "#inicio", label: "Inicio" },
  { href: "#nosotros", label: "Nosotros" },
  { href: "#pastores", label: "Pastores" },
  { href: "#contacto", label: "Contacto" },
  { href: "#soynuevo", label: "Soy Nuevo" },
];

const contactLinks = [
  { href: "tel:+50764330014", label: "Teléfono: (507) 6433-0014" },
  {
    href: "mailto:iglesiaevangelicalafe@hotmail.com",
    label: "Email: iglesiaevangelicalafe@gmail.com",
  },
  {
    href: "/visitanos",
    label:
      "Ubicación: Subiendo por escuela primaria, San Miguelito, Provincia de Panamá",
  },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Logo and Social Media Section */}
          <div className="footer-left">
            <img
              src="/logoIglesiaWhite.svg"
              alt="Iglesia Evangelica de la Fe Logo"
              className="footer-logo"
            />
            <p className="footer-description">
              Una comunidad de fe comprometida con el amor de Cristo y el
              servicio a la comunidad.
            </p>
            <div className="social-media">
              {socialLinks.map(({ href, label, icon }) => (
                <a
                  key={label}
                  href={href}
                  aria-label={label}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                >
                  <img src={icon} alt={label} className="social-icon" />
                </a>
              ))}
            </div>
          </div>

          {/* Navigation Links Section */}
          <div className="footer-center">
            <div className="useful-links">
              <h4>Enlaces Útiles</h4>
              <ul>
                {usefulLinks.map(({ href, label }) => (
                  <li key={label}>
                    <a href={href} className="footer-link">
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Contact Information Section */}
          <div className="footer-right">
            <div className="contact-info">
              <h4>Información de Contacto</h4>
              <ul>
                {contactLinks.map(({ href, label }) => (
                  <li key={label}>
                    <a href={href} className="footer-link">
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="footer-bottom">
          <p>
            &copy; 2024 Iglesia Evangelica de la Fe. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
